<template>
  <div class="o-table__header" v-if="headers.length !== 0">
    <div v-if="checkable || singleCheckable" class="es-xs-1">
      <Checkbox
        :key="checkboxKey"
        @change="
          $emit(
            'change:checkedAll',
            checkedList.length !== items.length
              ? true
              : checkedList.length === 0
              ? true
              : false
          )
        "
        :not-all="checkedList.length !== items.length"
        opposite
        :value="checkedList.length !== 0"
        v-if="checkable"
      ></Checkbox>
      <div v-if="checkable" class="chekbox-lg">
        <label>
          <b
            @click="
              $emit(
                'change:checkedAll',
                checkedList.length !== items.length
                  ? true
                  : checkedList.length === 0
                  ? true
                  : false
              )
            "
            :class="{
              'not-all': checkedList.length !== items.length,
              checked: checkedList.length !== 0,
            }"
            class="checkmark"
          ></b>
        </label>
      </div>
    </div>
    <div
      v-for="(header, i) in headersData"
      :key="'c' + i"
      @click="SET_SORT_OF_HEADER(header, i)"
      class="o-table__header__item"
      :class="`
      ${header.col ? `es-xs-${header.col}` : ''}
      ${header.sm ? `es-sm-${header.sm}` : ''}
      ${header.md ? `es-md-${header.md}` : ''}
      ${header.lg ? `es-lg-${header.lg}` : ''}
      ${header.xl ? `es-xl-${header.xl}` : ''}
      ${header.xxl ? `es-xxl-${header.xxl}` : ''}
      ${header.align ? `u-text-align-${header.align}` : ''}
      ${header.sortable ? 'o-table__header__item--sortable' : ''}
      `"
    >
      {{ i18n ? $t(header.title) : header.title }}

      <i
        v-if="header.sortable"
        class="o-table__header__item__sort-icon"
        :class="`icofont-rounded-${
          header.sort?.includes('desc')
            ? 'up'
            : header.sort?.includes('asc')
            ? 'up o-table__header__item__sort-icon--reverse'
            : 'up o-table__header__item__sort-icon--reverse-90'
        }`"
      ></i>
    </div>
  </div>
</template>

<script>
import Checkbox from "../Inputs/Checkbox.vue";
export default {
  components: { Checkbox },
  props: {
    headers: {
      default: () => [],
    },
    items: {
      default: () => [],
    },
    checkedList: {
      default: () => [],
    },
    checkable: {
      default: false,
      type: Boolean,
    },
    singleCheckable: {
      default: false,
      type: Boolean,
    },
    allChecked: {
      default: false,
      type: Boolean,
    },
    i18n: {
      default: false,
      type: Boolean,
    },
    scrollLeft: {
      default: 0,
    },
  },
  data() {
    return {
      checkboxKey: 1,
      headersData: [],
      resetHeadersData: this.headers,
    };
  },
  watch: {
    "checkedList.length"() {
      this.checkboxKey += 1;
    },
  },
  methods: {
    CLEAR_SORT() {
      this.headersData = this.headersData.map((header) => ({
        ...header,
        sort: "",
      }));
    },
    SET_SORT_OF_HEADER(header, i) {
      if (!header.sortable) return;
      const sort = header.sort;
      if (sort?.includes("asc")) this.headersData[i].sort = ``;
      else if (sort?.includes("desc"))
        this.headersData[i].sort = `${header.value}-asc`;
      else {
        this.CLEAR_SORT();
        this.headersData[i].sort = `${header.value}-desc`;
      }

      this.$emit("change:sort", this.headersData[i], this.headersData);
    },
  },
  mounted() {
    this.headersData = this.headers;
  },
};
</script>

<style></style>
